import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { VisitQuery as VisitQueryType, VisitQueryVariables } from "./__generated__/VisitQuery";

const VisitQuery = loader("./VisitQuery.gql");

type VisitQueryProviderType = (props: {
  children: (data: VisitQueryType) => ReactNode;
  variables: VisitQueryVariables;
}) => ReactElement;

export const VisitQueryProvider: VisitQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<VisitQueryType, VisitQueryVariables>(VisitQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
